import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceChip } from '../../components/ui/Choice';
import { TextAreaField } from '../../components/ui/Field';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { getInterestOptions, OTHER_INTEREST } from '../../data/quizOptions';
import { useCopy } from '../../contexts/LanguageContext';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
interface StepInterestsProps extends StepProps {
  customInterest: string;
  onCustomInterestChange: (value: string) => void;
}
export function StepInterests({
  profile,
  update,
  onNext,
  customInterest,
  onCustomInterestChange
}: StepInterestsProps) {
  const copy = useCopy();
  const options = getInterestOptions(profile.child_gender);
  const showCustom = profile.child_interests.includes(OTHER_INTEREST);
  const canContinue = profile.child_interests.length > 0 && (!showCustom || customInterest.trim().length > 0);
  return <div className="flex flex-1 flex-col" data-id="element-129" data-mp="3h2kjxwryyh69">
      <Headline data-id="element-130" data-mp="3h1j5dibqvcjs">{copy.steps.interests.headline(profile.child_name)}</Headline>
      <Subtext data-id="element-131" data-mp="3c2zldngpoau2">{copy.steps.interests.subtext}</Subtext>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-132" data-mp="3c1eq1vmkonv5">
        {options.map(option => <ChoiceChip key={option.key} emoji={option.emoji} label={copy.options.interests[option.key]} selected={profile.child_interests.includes(option.key)} onSelect={() => update({
        child_interests: toggleValue(profile.child_interests, option.key)
      })} data-id="element-133" data-mp="383qrmilo8cyi" />)}
      </div>

      <AnimatePresence initial={false} data-id="element-134" data-mp="3qrc9xzdgyrej">
        {showCustom && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-135" data-mp="2kc1pybmymc4w">
            <div className="pt-5" data-id="element-136" data-mp="2gsb3fjpu4ylb">
              <TextAreaField id="custom-interest" label={copy.steps.interests.otherLabel} rows={3} value={customInterest} onChange={onCustomInterestChange} placeholder={copy.steps.interests.otherPlaceholder} data-id="element-137" data-mp="2lu0h774fzqd3" />
            </div>
          </motion.div>}
      </AnimatePresence>

      <div className="mt-auto pt-10" data-id="element-138" data-mp="22ucs6n6t9ia1">
        <PrimaryButton onClick={onNext} disabled={!canContinue} data-id="element-139" data-mp="22veghtcu819p">
          {copy.quiz.continue}
        </PrimaryButton>
      </div>
    </div>;
}